<template>
  <b-modal
    :id="modalIdentifier"
    body-class="p-0"
    hide-footer
    hide-header
    lazy
    no-close-on-backdrop
    no-close-on-esc
    ok-disabled
    size="lg"
    static
    :hide-backdrop="hideBackdrop"
  >
    <div class="modal-container">
      <div class="modal-header bg-primary-6 px-4 py-2">
        <h5 class="modal-title color-white font-weight-normal">
          {{ title }}
        </h5>
        <custom-icon
          class="modal-container__close-icon"
          icon="x-circle"
          @click.native="hideModal"
        />
      </div>
      <div class="body-content px-4 py-4">
        <slot />
      </div>
      <div class="px-4 py-3">
        <slot name="footer" />
      </div>
    </div>
  </b-modal>
</template>

<script>
//components
import { CustomIcon } from '@/components/common';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'CustomModal',
  components: {
    CustomIcon,
  },
  mixins: [alertMixin],
  data: function () {
    return {
      acceptTermsChecked: false,
    };
  },
  props: {
    id: {
      type: String,
      default: () => 'modalIdentifier',
    },
    title: {
      type: String,
      default: () => '',
    },
    text: {
      type: String,
      default: () => '',
    },
    checkTitle: {
      type: String,
      default: () => '',
    },
    hideBackdrop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalIdentifier() {
      return this.id;
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show(this.modalIdentifier);
    },
    hideModal() {
      this.$emit('hide');
      this.$bvModal.hide(this.modalIdentifier);
    },
    acceptHandler() {
      if (!this.acceptTermsChecked) {
        this.ShowToast(
          'Error',
          'Favor aceptar los términos y condiciones.',
          'error'
        );

        return;
      }

      this.$emit('accept');
      this.hideModal();
      this.acceptTermsChecked = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.modal-container {
  &__close-icon {
    color: map-get($colors, 'white');
    font-size: 1.25rem;
  }
  .modal-header {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 4px 4px 0px 0px;
  }
  .modal-footer {
    border-top: unset;
  }
}
:deep(.modal-content) {
  border: unset;
}
</style>
